import { IStaffDepartment } from "../../interfaces-and-types";

import notificationCircle from "../../assets/icons/notificationCircle.svg";
import { truncateStringWithEllipsis } from "../../utils";

export const HelpView = () => {
  return (
    <div className="flex-container col">
      <div className="help-top">
        <div className="flex-container col">
          <div className="help-title">Resources</div>
          <div className="padded-sub-help-list flex-container col">
            <a
              className="flex-container row"
              href="https://docs.switchappgo.com/"
              target={"_blank"}
              rel="noreferrer"
            >
              Support articles{" "}
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
              </svg>
            </a>
            <a
              className="flex-container row"
              href="https://docs.switchappgo.com/"
              target={"_blank"}
              rel="noreferrer"
            >
              Developer docs{" "}
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
              </svg>
            </a>
            {/* <a className="flex-container row" href="#">
              Keyboard shortcut
            </a> */}
          </div>
        </div>

        <div className="flex-container col">
          <div className="help-title">get in touch</div>
          <div className="padded-sub-help-list flex-container col">
            <a className="flex-container row" href="#">
              Share feedback
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
